/* src/app/components/leads/form-checklist/form-checklist.component.css */
::ng-deep .reverse-accordion-body .accordion-body {
  flex-direction: column-reverse;
}
/*# sourceMappingURL=form-checklist.component-LGTNARTI.css.map */
